import { GraphExample } from './content-creator/graph-model';
import { MarkdownText } from './markdown-text';

export function GraphExampleContent({ example }: { example: GraphExample }) {
    return <div className="graph-example-content">
        <MarkdownText text={example.desc} />
        {example.hint && <div className="mt-3 p-3 surface-ground border-round"><MarkdownText text={example.hint} /></div>}
        {!!example.items?.length && <section className="mt-3" aria-label="Examples">
            <h3 className="text-base mb-2">Examples</h3>
            <ul className="pl-4 m-0">{example.items.map((item, index) => <li key={index} className="mb-2"><MarkdownText text={item} inline /></li>)}</ul>
        </section>}
    </div>;
}
